module.exports = __webpack_public_path__ + "static/media/new-campaigns-graphic.ac899a75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/new-campaigns-graphic.svg
// module id = 1251
// module chunks = 0